

















import {
  TableContent,
  TableTdContent,
  SubjectiveContent,
} from '@/resource/question/question.type';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ComponentSubjective: () =>
      import(
        '@/components/questions/subjective-components/ComponentSubjective.vue'
      ),
  },
})
export default class SubjectiveTable extends Vue {
  @Prop({ required: true })
  content!: TableContent;

  get tableTh() {
    return this.content.content[0].content as SubjectiveContent[];
  }

  get tableTds() {
    const [th, ...tds] = this.content.content;
    th;
    return tds as TableTdContent[];
  }
}
